import { BrowserDetection } from '@jitsi/js-utils';
import React from 'react';

import { SAFARI } from '../../../../browser';
import {
    setAudioInputDeviceAndUpdateSettings,
    setAudioOutputDevice,
    setVideoInputDeviceAndUpdateSettings
} from '../../base/devices';
import { translate } from '../../base/i18n';
import { connect } from '../../base/redux';

import AudioOutputPreview from './AudioOutputPreview';

const bowser = new BrowserDetection();
const browserName = bowser.getName();

/**
 * SelectDevices component props.
 */
class SelectDevices extends React.Component<Props, State> {
    /**
     * Constructor
     */
    constructor(props: Props) {
        super(props);

        this.state = {
            previewAudioTrack: null,
            previewVideoTrack: null,
            previewVideoTrackError: null
        };
        this._unMounted = true;
    }

    _onVideoInputDeviceChange = event => {
        const selectedVideoInputId = event.target.value;

        this.props.setVideoInputDevice(selectedVideoInputId);
    };

    _onAudioInputDeviceChange = event => {
        const selectedAudioInputId = event.target.value;

        this.props.setAudioInputDevice(selectedAudioInputId);
    };

    _onAudioOutputDeviceChange = event => {
        const selectedAudioOutputId = event.target.value;

        this.props.setAudioOutputDevice(selectedAudioOutputId);
    };

    /**
     * Render Function
     * **/
    render() {
        const selectedAudioInputId = this.props.selectedAudioInputId;
        const selectedAudioOutputId = this.props.selectedAudioOutputId;
        const selectedVideoInputId = this.props.selectedVideoInputId;
        const { t } = this.props;

        return (
            <div className = 'select-devices'>
                <div className = 'device-selectors'>
                    <div className = 'device-selector select-wrapper camera-wrapper'>
                        <span className = 'device-selector-label'>{t('settings.selectCamera')}</span>
                        <select
                            className = 'device-selector-camera'
                            onChange = { this._onVideoInputDeviceChange }
                            value = { selectedVideoInputId }>
                            {this.props.availableDevices.videoInput.map(device => (
                                <option
                                    key = { device.deviceId }
                                    value = { device.deviceId }>
                                    {device.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className = 'device-selector select-wrapper mic-wrapper'>
                        <span className = 'device-selector-label'>{t('settings.selectMic')}</span>
                        <select
                            className = 'device-selector-mic'
                            onChange = { this._onAudioInputDeviceChange }
                            value = { selectedAudioInputId }>
                            {this.props.availableDevices.audioInput.map(device => (
                                <option
                                    key = { device.deviceId }
                                    value = { device.deviceId }>
                                    {device.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    {browserName !== SAFARI && (
                        <div className = 'device-selector select-wrapper speaker-wrapper'>
                            <span className = 'device-selector-label'>{t('settings.selectSpeaker')}</span>
                            <select
                                className = 'device-selector-speaker'
                                onChange = { this._onAudioOutputDeviceChange }
                                value = { selectedAudioOutputId }>
                                {this.props.availableDevices.audioOutput.map(device => (
                                    <option
                                        key = { device.deviceId }
                                        value = { device.deviceId }>
                                        {device.label}
                                    </option>
                                ))}
                            </select>
                        </div>)}
                    <div className = 'device-selector'>
                        {!this.props.hideAudioOutputSelect
                            && <AudioOutputPreview deviceId = { this.props.selectedAudioOutputId } />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = {
    setVideoInputDevice: setVideoInputDeviceAndUpdateSettings,
    setAudioInputDevice: setAudioInputDeviceAndUpdateSettings,
    setAudioOutputDevice
};

export default translate(connect(null, mapDispatchToProps)(SelectDevices));
